import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../images/star.png';

const _withScopeId = n => (_pushScopeId("data-v-3541803e"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "description-warp",
  "element-loading-background": "transparent"
};
const _hoisted_2 = {
  class: "info-warp"
};
const _hoisted_3 = {
  key: 0,
  class: "cover"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "detail"
};
const _hoisted_6 = {
  class: "title"
};
const _hoisted_7 = {
  class: "rating"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("img", {
  class: "start",
  src: _imports_0,
  alt: ""
})], -1));

const _hoisted_9 = {
  class: "main"
};
const _hoisted_10 = {
  class: "tag"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  class: "introduce"
};
const _hoisted_13 = {
  class: "introduce-content"
};

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "span-title"
}, /*#__PURE__*/_toDisplayString(':البلد'), -1));

const _hoisted_15 = {
  class: "introduce-content"
};

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "span-title"
}, /*#__PURE__*/_toDisplayString(':اللغة'), -1));

const _hoisted_17 = {
  class: "introduce-content"
};

const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "span-title"
}, /*#__PURE__*/_toDisplayString(':الوقت'), -1));

const _hoisted_19 = {
  class: "introduce-content"
};

const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "span-title"
}, /*#__PURE__*/_toDisplayString(':نشر البيانات'), -1));

const _hoisted_21 = {
  class: "introduce-content"
};

const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "span-title"
}, /*#__PURE__*/_toDisplayString(':السيريوم فعل'), -1));

const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "span-title"
}, /*#__PURE__*/_toDisplayString(':المدير'), -1));

const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "span-title"
}, /*#__PURE__*/_toDisplayString(':ممثل'), -1));

const _hoisted_25 = {
  class: "buttons"
};

const _hoisted_26 = /*#__PURE__*/_createTextVNode( /*#__PURE__*/_toDisplayString('ساينس'));

const _hoisted_27 = /*#__PURE__*/_createTextVNode( /*#__PURE__*/_toDisplayString('روائي'));

const _hoisted_28 = /*#__PURE__*/_createTextVNode( /*#__PURE__*/_toDisplayString('فانتاشي'));

const _hoisted_29 = /*#__PURE__*/_createTextVNode( /*#__PURE__*/_toDisplayString('خارق'));

const _hoisted_30 = /*#__PURE__*/_createTextVNode( /*#__PURE__*/_toDisplayString('مقطورة'));

const _hoisted_31 = /*#__PURE__*/_createTextVNode( /*#__PURE__*/_toDisplayString('مقدمة'));

const _hoisted_32 = /*#__PURE__*/_createTextVNode( /*#__PURE__*/_toDisplayString('تعليقات المستخدمين'));

const _hoisted_33 = {
  class: "operation"
};
const _hoisted_34 = ["onClick"];
const _hoisted_35 = ["src"];
const _hoisted_36 = {
  key: 0,
  class: "episode"
};
const _hoisted_37 = {
  class: "episode-list"
};
const _hoisted_38 = ["tabindex", "onClick"];
const _hoisted_39 = {
  class: "recommend-warp"
};

const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "word"
}, /*#__PURE__*/_toDisplayString('التوصية')), /*#__PURE__*/_createElementVNode("span", {
  class: "line"
})], -1));

const _hoisted_41 = {
  class: "recommend-list",
  "element-loading-background": "transparent"
};
const _hoisted_42 = ["onClick"];
const _hoisted_43 = ["onClick"];
const _hoisted_44 = {
  class: "detail-dialog-warp",
  "element-loading-background": "transparent"
};

const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "Plot Summary", -1));

const _hoisted_46 = {
  class: "info"
};
const _hoisted_47 = {
  class: "favorite-warp"
};

const _hoisted_48 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "+", -1));

const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "创建收藏夹", -1));

const _hoisted_50 = [_hoisted_48, _hoisted_49];
const _hoisted_51 = {
  class: "favorite-list"
};
const _hoisted_52 = ["onClick"];
const _hoisted_53 = {
  class: "name"
};
const _hoisted_54 = {
  class: "count"
};
const _hoisted_55 = {
  "element-loading-background": "transparent"
};
const _hoisted_56 = {
  class: "trailer-dialog-warp",
  "element-loading-background": "transparent"
};
const _hoisted_57 = {
  class: "name"
};
const _hoisted_58 = ["src"];
import { inject, onMounted } from 'vue';
import RecommendItem from './recommendItem.vue';
import MoviesOrActorItem from './moviesOrActorItem.vue';
import ElTabs from '../../../components/ElTabs/index.vue';
import { axiosInstanceAll } from '@/api/instance';
import { getFavoritesListApi, collectOrCancleApi, favoritesCategoryApi, savePlayHistoryInfoApi } from '@/api/vodPlus';
import { elMessage, vodPlusBaseUrl } from '@/utils';
import DetailDialog from './detailDialog.vue';
import { useI18n } from 'vue-i18n';
import { formValidator } from '@/utils/validate';
export default /*#__PURE__*/_defineComponent({
  __name: 'description',
  emits: ['onCardClick'],

  setup(__props, {
    emit
  }) {
    const {
      t
    } = useI18n();
    const favoriteMenuList = ref([]);
    const operationBtnList = ref([{
      url: require('../../images/icon_play.png'),
      selUrl: require('../../images/icon_play_sel.png'),
      click: async () => {
        if (currentParams.value.type == 'series') return;

        try {
          let params = {
            action: 0,
            id: currentParams.value.id,
            categoryid: 0,
            timeShift: 1,
            programtype: 1
          };
          const res = await savePlayHistoryInfoApi(params);

          if (res.status == 200) {
            alert(detailInfo.value.terminalStateUrl);
          }
        } catch (error) {}
      }
    }, {
      url: require('../../images/icon_favourite.png'),
      selUrl: require('../../images/icon_favourite_sel.png'),
      click: async () => {
        return;
        favoriteOptions.visible = true;
        getFavoritesList();
      }
    }, {
      url: require('../../images/ic_good.png'),
      selUrl: require('../../images/ic_good_sel.png'),
      click: () => {}
    }]);

    const episodeItemClick = async item => {
      try {
        let params = {
          action: 0,
          id: item.id,
          categoryid: 0,
          timeShift: 1,
          programtype: 0,
          seriesid: currentParams.value.id
        };
        const res = await savePlayHistoryInfoApi(params);

        if (res.status == 200) {
          alert(detailInfo.value.terminalStateUrl);
        }
      } catch (error) {}
    };

    const createFavoriteRef = ref(null);
    const favoriteOptions = reactive({
      visible: false,
      loading: false,
      dialogConfig: {
        title: '添加到收藏',
        destroyOnClose: true,
        isShowFooter: false
      },
      close: () => {}
    });
    const createFavoriteOptions = reactive({
      visible: false,
      loading: false,
      dialogConfig: {
        title: '创建收藏目录',
        destroyOnClose: true
      },
      confirm: done => {
        formValidator(createFavoriteRef.value.mForm).then(() => {
          favoritesCategory(done);
        }, () => done());
      },
      formList: [[{
        label: '名称',
        prop: 'name',
        widgetType: 'input',
        required: true
      }]],
      formData: {
        name: ''
      },
      rules: {
        name: [{
          required: true,
          message: t('请输入名称'),
          trigger: 'blur'
        }]
      }
    });
    const dataConfig = reactive({
      data: [],
      loading: false,
      recommendLoading: false,
      page: {
        page: 1,
        limit: 20,
        total: 0
      }
    });
    const detailDialogConfig = reactive({
      visible: false,
      loading: false,
      data: ''
    });
    const trailerConfig = reactive({
      visible: false,
      loading: false,
      playUrl: ''
    });
    const currentEpisodeTabNum = ref(1);
    const episodeList = ref([]);
    const episodeNumList = ref([]);
    const recommendList = ref([]); // 详情内容对象

    const detailInfo = ref({});

    const recommendItemClick = item => {
      emit('onCardClick', item);
    };

    onMounted(() => {
      const previewWarp = document.querySelector('.preview-warp');
      previewWarp && previewWarp.scrollTo(0, 0);
      getData();
    });

    const onDirectorClick = () => {
      console.log(detailInfo.value);
      let item = {
        type: 'castOrDirector_list',
        imdbId: detailInfo.value.imdbId,
        apiType: 2
      };
      emit('onCardClick', item);
    };

    const onActorClick = () => {
      console.log(detailInfo.value);
      let item = {
        type: 'castOrDirector_list',
        imdbId: detailInfo.value.imdbId,
        apiType: 1
      };
      emit('onCardClick', item);
    };

    const getData = async () => {
      dataConfig.loading = true;

      try {
        const {
          detailUrl,
          type
        } = currentParams.value;
        console.log('detailUrl', detailUrl);
        const res = await axiosInstanceAll({
          method: 'get',
          url: '/vodPlus' + detailUrl.replace(vodPlusBaseUrl, ''),
          params: {
            usertoken: sessionStorage.getItem('vodPlusToken')
          }
        });
        console.log(res);

        if (res.status == 200) {
          detailInfo.value = res.data;
        }

        if (type == 'series') {
          returnAllPageFunc();
          dataConfig.page.total = res.data.seriesList.totalNum;
          formateEpisodeTabList();
        }

        getRelativeRecommend();
      } catch (error) {
        console.log(error);
      }

      dataConfig.loading = false;
    }; // 获取推荐列表


    const getRelativeRecommend = async () => {
      // const res = await getRelativeRecommendApi({ total: 7 }) as any
      dataConfig.recommendLoading = true;

      try {
        const {
          relativeRecommend
        } = detailInfo.value;
        const res = await axiosInstanceAll({
          method: 'get',
          url: '/vodPlus' + relativeRecommend.replace(vodPlusBaseUrl, ''),
          params: {
            usertoken: sessionStorage.getItem('vodPlusToken')
          }
        });
        console.log(res);

        if (res.status == 200) {
          recommendList.value = res.data.list || [];
        }
      } catch (error) {}

      dataConfig.recommendLoading = false;
    }; // 格式化剧集tab


    const formateEpisodeTabList = () => {
      const {
        seriesList
      } = detailInfo.value;

      if (seriesList && seriesList.list.length) {
        if (seriesList.totalNum < dataConfig.page.limit) {
          episodeList.value = [{
            name: '1-20',
            page: 1
          }];
        } else {
          let remainder = Math.ceil(seriesList.totalNum / dataConfig.page.limit);

          for (let i = 0; i < remainder; i++) {
            episodeList.value.unshift({
              name: i * dataConfig.page.limit + 1 + '-' + dataConfig.page.limit * (i + 1),
              page: i + 1
            });
          }
        }
      }
    };

    const handleTabClick = item => {
      currentEpisodeTabNum.value = item.props.name;
      dataConfig.page.page = item.props.name;
      returnAllPageFunc();
    }; // 标签点击事件


    const tagItemClick = item => {
      let params = {
        programListUrl: detailInfo.value.propertyFilter + `&property=${item}`,
        type: 'all',
        name: item
      };
      emit('onCardClick', params);
    };

    const returnAllPageFunc = async () => {
      const {
        seriesList
      } = detailInfo.value;
      let newArr = JSON.parse(JSON.stringify(seriesList.list));
      episodeNumList.value = newArr.splice((dataConfig.page.page - 1) * dataConfig.page.limit, dataConfig.page.limit);
    };

    const onTrailerClick = async () => {
      trailerConfig.visible = true;
      trailerConfig.loading = true;

      try {
        const {
          trailerUrl
        } = detailInfo.value;
        const res = await axiosInstanceAll({
          method: 'get',
          url: '/vodPlus' + trailerUrl.replace(vodPlusBaseUrl, ''),
          params: {
            usertoken: sessionStorage.getItem('vodPlusToken')
          }
        });
        console.log(res);

        if (res.status == 200) {
          trailerConfig.playUrl = res.data.urlobj.length && res.data.urlobj[0].playUrl;
        }
      } catch (error) {}

      trailerConfig.loading = false;
    };

    const onPlotSummaryClick = async () => {
      detailDialogConfig.visible = true;
      detailDialogConfig.loading = true;

      try {
        const {
          descriptionUrl
        } = detailInfo.value;
        const res = await axiosInstanceAll({
          method: 'get',
          url: '/vodPlus' + descriptionUrl.replace(vodPlusBaseUrl, ''),
          params: {
            usertoken: sessionStorage.getItem('vodPlusToken')
          }
        });
        console.log(res);

        if (res.status == 200) {
          detailDialogConfig.data = res.data;
        }
      } catch (error) {}

      detailDialogConfig.loading = false;
    };

    const favoriteItemClick = async item => {
      console.log(item);

      try {
        favoriteOptions.loading = true;
        let params = {
          action: 1,
          categoryid: item.id,
          pid: detailInfo.value.id
        };
        const res = await collectOrCancleApi(params);
        console.log(res);

        if (res.status == 200) {
          elMessage('info', res.data.result);
        }
      } catch (error) {}

      favoriteOptions.loading = false;
      favoriteOptions.visible = false;
    }; // 获取收藏目录列表


    const getFavoritesList = async () => {
      try {
        favoriteOptions.loading = true;
        favoriteMenuList.value = [];
        const res = await getFavoritesListApi({});

        if (res.status == 200) {
          favoriteMenuList.value = res.data;
        }
      } catch (error) {}

      favoriteOptions.loading = false;
    };

    const createFavorite = () => {
      createFavoriteOptions.visible = true;
    };

    const favoritesCategory = async done => {
      try {
        const res = await favoritesCategoryApi({
          action: 1,
          categoryname: createFavoriteOptions.formData.name
        });

        if (res.status == 200) {
          elMessage('success', '操作成功');
          createFavoriteOptions.visible = false;
          getFavoritesList();
        }
      } catch (error) {}

      done();
    };

    const currentUiStyleOptions = inject('currentUiStyleOptions');
    const currentParams = inject('currentParams');
    const isArabicStyle = computed(() => {
      return currentUiStyleOptions.value.styleName == 'arabic';
    });
    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_empty = _resolveComponent("el-empty");

      const _component_m_dialog = _resolveComponent("m-dialog");

      const _component_FormTable = _resolveComponent("FormTable");

      const _directive_loading = _resolveDirective("loading");

      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [!dataConfig.loading ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["arabic-lang-class", _unref(currentUiStyleOptions).class])
      }, [_createElementVNode("div", _hoisted_2, [_unref(currentUiStyleOptions).showImg ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("img", {
        src: _unref(detailInfo).poster,
        alt: ""
      }, null, 8, _hoisted_4)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", null, _toDisplayString(_unref(detailInfo).programName), 1), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("span", null, _toDisplayString(_unref(detailInfo).rating), 1)])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(detailInfo).property && _unref(detailInfo).property.split(','), (item, index) => {
        return _openBlock(), _createElementBlock("span", {
          class: "tag-item pointer",
          key: index,
          onClick: $event => tagItemClick(item)
        }, _toDisplayString(item), 9, _hoisted_11);
      }), 128))]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_row, {
        class: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createElementVNode("span", _hoisted_13, _toDisplayString(_unref(detailInfo).country), 1), _hoisted_14]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createElementVNode("span", _hoisted_15, _toDisplayString(_unref(detailInfo).language), 1), _hoisted_16]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createElementVNode("span", _hoisted_17, _toDisplayString(_unref(detailInfo).runtime), 1), _hoisted_18]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createElementVNode("span", _hoisted_19, _toDisplayString(_unref(detailInfo).releaseDate), 1), _hoisted_20]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createElementVNode("span", _hoisted_21, _toDisplayString(_unref(detailInfo).ceritification), 1), _hoisted_22]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createElementVNode("span", {
            onClick: onDirectorClick,
            class: "color-text introduce-content"
          }, _toDisplayString(_unref(detailInfo).director), 1), _hoisted_23]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createElementVNode("span", {
            onClick: onActorClick,
            class: "color-text introduce-content"
          }, _toDisplayString(_unref(detailInfo).cast), 1), _hoisted_24]),
          _: 1
        })]),
        _: 1
      })]), _createElementVNode("div", _hoisted_25, [_createVNode(_component_el_row, null, {
        default: _withCtx(() => [_unref(currentParams).type == 'series' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createVNode(_component_el_button, {
          class: "cms-op-btn-main"
        }, {
          default: _withCtx(() => [_hoisted_26]),
          _: 1
        }), _createVNode(_component_el_button, {
          class: "cms-op-btn-main"
        }, {
          default: _withCtx(() => [_hoisted_27]),
          _: 1
        }), _createVNode(_component_el_button, {
          class: "cms-op-btn-main"
        }, {
          default: _withCtx(() => [_hoisted_28]),
          _: 1
        }), _createVNode(_component_el_button, {
          class: "cms-op-btn-main"
        }, {
          default: _withCtx(() => [_hoisted_29]),
          _: 1
        })], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createVNode(_component_el_button, {
          disabled: !_unref(detailInfo).trailerUrl,
          onClick: onTrailerClick,
          class: "cms-op-btn-main"
        }, {
          default: _withCtx(() => [_hoisted_30]),
          _: 1
        }, 8, ["disabled"]), _createVNode(_component_el_button, {
          class: "cms-op-btn-main",
          onClick: onPlotSummaryClick
        }, {
          default: _withCtx(() => [_hoisted_31]),
          _: 1
        }), _createVNode(_component_el_button, {
          class: "cms-op-btn-main"
        }, {
          default: _withCtx(() => [_hoisted_32]),
          _: 1
        })], 64))]),
        _: 1
      })]), _createElementVNode("div", _hoisted_33, [_createVNode(_component_el_row, null, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(operationBtnList.value, (item, index) => {
          return _openBlock(), _createElementBlock("span", {
            class: "span-item pointer",
            onClick: item.click,
            key: index
          }, [_createElementVNode("img", {
            src: item.selUrl,
            alt: ""
          }, null, 8, _hoisted_35)], 8, _hoisted_34);
        }), 128))]),
        _: 1
      })])])])]), _unref(currentParams).type == 'series' ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_createVNode(ElTabs, {
        "tab-lists": episodeList.value,
        "tab-active-name": currentEpisodeTabNum.value,
        "tab-value": "page",
        onOnTabClick: handleTabClick
      }, null, 8, ["tab-lists", "tab-active-name"]), _createElementVNode("div", _hoisted_37, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(episodeNumList.value || [], (item, index) => {
        return _openBlock(), _createElementBlock("span", {
          tabindex: index,
          class: "episode-item pointer",
          key: index,
          onClick: $event => episodeItemClick(item)
        }, _toDisplayString(item.number), 9, _hoisted_38);
      }), 128))])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_39, [_hoisted_40, _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_41, [_unref(currentUiStyleOptions).styleName == 'style2' ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(recommendList.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          onClick: $event => recommendItemClick(item),
          key: index
        }, [_createVNode(RecommendItem, {
          infoItem: item
        }, null, 8, ["infoItem"])], 8, _hoisted_42);
      }), 128)) : _createCommentVNode("", true), _unref(currentUiStyleOptions).styleName == 'default' || _unref(currentUiStyleOptions).styleName == 'style1' || _unref(currentUiStyleOptions).styleName == 'arabic' ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 1
      }, _renderList(recommendList.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          onClick: $event => recommendItemClick(item),
          key: index,
          class: "recommend-item pioneer"
        }, [_createVNode(MoviesOrActorItem, {
          poster: item.poster,
          programName: item.programName
        }, null, 8, ["poster", "programName"])], 8, _hoisted_43);
      }), 128)) : _createCommentVNode("", true), !recommendList.value.length && !dataConfig.recommendLoading ? (_openBlock(), _createBlock(_component_el_empty, {
        key: 2,
        description: "لا توجد بيانات",
        style: {
          "width": "100%"
        },
        "image-size": 50
      })) : _createCommentVNode("", true)])), [[_directive_loading, dataConfig.recommendLoading]])])], 2)) : _createCommentVNode("", true), _createVNode(DetailDialog, {
        modelValue: detailDialogConfig.visible,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => detailDialogConfig.visible = $event),
        "main-width": "52.083vw"
      }, {
        content: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_44, [_hoisted_45, _createElementVNode("p", _hoisted_46, _toDisplayString(detailDialogConfig.data), 1)])), [[_directive_loading, detailDialogConfig.loading]])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_m_dialog, {
        autoLoading: "",
        modelValue: favoriteOptions.visible,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => favoriteOptions.visible = $event),
        nativeConfig: {
          width: '26.042vw',
          top: '20vh',
          closeOnClickModal: false
        },
        "dialog-config": favoriteOptions.dialogConfig,
        onOnClose: favoriteOptions.close
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_47, [_createElementVNode("div", null, [_createElementVNode("div", {
          class: "add-btn pointer",
          onClick: createFavorite
        }, _hoisted_50), _createElementVNode("div", _hoisted_51, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(favoriteMenuList.value, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: "pointer favorite-item",
            onClick: $event => favoriteItemClick(item)
          }, [_createElementVNode("span", _hoisted_53, _toDisplayString(item.categoryname), 1), _createElementVNode("span", _hoisted_54, _toDisplayString(item.programlist.length), 1)], 8, _hoisted_52);
        }), 128))])])])), [[_directive_loading, favoriteOptions.loading]])]),
        _: 1
      }, 8, ["modelValue", "nativeConfig", "dialog-config", "onOnClose"]), _createVNode(_component_m_dialog, {
        autoLoading: "",
        modelValue: createFavoriteOptions.visible,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => createFavoriteOptions.visible = $event),
        nativeConfig: {
          width: '26.042vw',
          top: '30vh',
          closeOnClickModal: false,
          customClass: 'create-favorite-dialog'
        },
        "dialog-config": createFavoriteOptions.dialogConfig,
        onOnConfirm: createFavoriteOptions.confirm
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_55, [_createVNode(_component_FormTable, {
          ref_key: "createFavoriteRef",
          ref: createFavoriteRef,
          "form-list": createFavoriteOptions.formList,
          "form-data": createFavoriteOptions.formData,
          rules: createFavoriteOptions.rules
        }, null, 8, ["form-list", "form-data", "rules"])])), [[_directive_loading, createFavoriteOptions.loading]])]),
        _: 1
      }, 8, ["modelValue", "nativeConfig", "dialog-config", "onOnConfirm"]), _createVNode(DetailDialog, {
        modelValue: trailerConfig.visible,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => trailerConfig.visible = $event),
        "main-width": "62.5vw"
      }, {
        content: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_56, [_createElementVNode("div", _hoisted_57, _toDisplayString(_unref(detailInfo).programName), 1), _createElementVNode("video", {
          controls: "",
          src: trailerConfig.playUrl
        }, null, 8, _hoisted_58)])), [[_directive_loading, trailerConfig.loading]])]),
        _: 1
      }, 8, ["modelValue"])])), [[_directive_loading, dataConfig.loading]]);
    };
  }

});